<template>
  <v-flex xs4 class="payment-method">
    <v-card flat
            hover
            height="120"
            class="center-align link"
            @click="$emit(method, value)">
      <div class="pt-4">
        <v-icon x-large>mdi-plus</v-icon>
      </div>
      <slot></slot>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    method: String,
    value: Object
  }
}
</script>



// WEBPACK FOOTER //
// add-card.vue?29b67660